"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImplicitRestClient = void 0;

var ImplicitRestClient =
/** @class */
function () {
  function ImplicitRestClient(restClient) {
    this.restClient = restClient;
  }

  ImplicitRestClient.prototype.get = function (requestPath, queryParameters, headers) {
    return this.restClient.get(requestPath, queryParameters);
  };

  ImplicitRestClient.prototype.post = function (requestPath, formParameters, headers) {
    return this.restClient.post(requestPath, formParameters);
  };

  ImplicitRestClient.prototype.postMultipart = function (requestPath, formParameters, headers) {
    return this.restClient.postMultipart(requestPath, formParameters);
  };

  return ImplicitRestClient;
}();

exports.ImplicitRestClient = ImplicitRestClient;